import { IconHouseBed16, IconPinMarker16, IconSearch16, IconUsers16 } from '@warp-ds/icons/react';
import { Button } from '@warp-ds/react';
import type { Filters } from '@/domain';
import { SearchDetailsDate } from '@/scenes/resultPage/components/newSearch/components/SearchDetailsDate';

export interface Props {
    filters: Filters;
    openSearchForm: () => void;
}

export const SearchDetails = ({ openSearchForm, filters }: Props) => {
    const guestText = () => {
        const beds = Number(filters.no_of_beds_from ?? 0);
        if (beds === 0) return 'Alle gjester';
        if (beds === 1) return '1 gjest';
        return <>{beds} gjester</>;
    };

    return (
        <div className="flex justify-between items-center gap-16 md:p-16" data-testid="searchDetails">
            <IconSearch16 className="md:hidden" aria-hidden />
            <div className="grow flex flex-row md:text-m m-divide divide-x-1">
                <div className="flex flex-col justify-center">
                    <div className="md:pr-24 pr-8 flex gap-8 justify-items-center items-center">
                        <IconPinMarker16 className="md:inline hidden" />
                        {filters.city || filters.country ? (
                            <span data-testid="searchDetailsDestination" className="md:inline text-s md:text-16">
                                {filters.city ? `${filters.city}, ${filters.country}` : filters.country}
                            </span>
                        ) : (
                            <span className="md:inline text-s md:text-16">Hvor som helst</span>
                        )}
                    </div>
                </div>
                <div className="flex flex-col justify-center">
                    <SearchDetailsDate fromDate={filters.booking_from} toDate={filters.booking_to} />
                </div>
                <div className="hidden md:flex flex-col justify-center px-16">
                    <div className="text-center pr-8 flex gap-8 justify-items-center items-center">
                        <IconUsers16 className="md:inline" />
                        <span data-testid="searchDetailsGuests" className="bottom-a align-text-bottom object-bottom">
                            {guestText()}
                        </span>
                    </div>
                </div>
                <div className="hidden md:flex flex-col justify-center px-16">
                    <div className="text-centerpx-8 flex gap-8 justify-items-center items-center">
                        <IconHouseBed16 className="md:inline" />
                        <span data-testid="searchDetailsBedrooms" className="bottom-a align-text-bottom object-bottom">
                            {filters.no_of_bedrooms_from === undefined || Number(filters.no_of_bedrooms_from) === 0
                                ? 'Alle'
                                : filters.no_of_bedrooms_from}{' '}
                            soverom
                        </span>
                    </div>
                </div>
            </div>
            <Button
                data-testid="openSearchFormButton"
                link
                onClick={openSearchForm}
                className="font-bold text-s md:text-m whitespace-nowrap">
                Endre søk
            </Button>
        </div>
    );
};
